var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 34.1843V14.7665C7.58594 9.53412 7.58594 6.91795 9.19685 5.29248C10.8078 3.66699 13.4005 3.66699 18.5859 3.66699H25.9193C31.1047 3.66699 33.6974 3.66699 35.3083 5.29248C36.9193 6.91795 36.9193 9.53412 36.9193 14.7665V34.1843C36.9193 36.9557 36.9193 38.3414 36.0723 38.8868C34.6883 39.7783 32.5488 37.9089 31.4726 37.2304C30.5835 36.6696 30.1391 36.3892 29.6455 36.3731C29.1124 36.3555 28.6599 36.6245 27.6993 37.2304L24.1959 39.4397C23.2509 40.0356 22.7784 40.3337 22.2526 40.3337C21.7268 40.3337 21.2544 40.0356 20.3093 39.4397L16.806 37.2304C15.9169 36.6696 15.4723 36.3892 14.9789 36.3731C14.4458 36.3555 13.9933 36.6245 13.0325 37.2304C11.9565 37.9089 9.81687 39.7783 8.43285 38.8868C7.58594 38.3414 7.58594 36.9557 7.58594 34.1843Z",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4141 20.167H14.9141",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9141 12.833H14.9141",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice01);
export default __webpack_public_path__ + "static/media/invoice-01.2fb57290ac6d7c0fd06fc583c2eb6229.svg";
export { ForwardRef as ReactComponent };